import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const dateSelectStyles: moduleStyleType = {
    root: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.border.primary,
        },
        '& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:not(.Mui-disabled):before':
            {
                border: 'none',
            },
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.error.main,
            '& .Mui-focused fieldset': {
                border: 'none',
            },
        },
        '& .MuiInputBase-root': {
            background: palette.background.default,
        },
        '& .MuiInputBase-input': {
            p: 2,
        },
    },
}
